import { render, staticRenderFns } from "./MarginFullCustoms.vue?vue&type=template&id=aecbd206"
import script from "./MarginFullCustoms.vue?vue&type=script&lang=js"
export * from "./MarginFullCustoms.vue?vue&type=script&lang=js"
import style0 from "./MarginFullCustoms.vue?vue&type=style&index=0&id=aecbd206&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports